import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import ListItemSelector from "../common/ListItemSelector";

const ClassStudentPickerModal = ({ show, options, isSubmitting, error, onSelect, onHide }) => {
  const [viewportHeight, setViewportHeight] = useState(null);
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!show || !viewport) return undefined;
    const updateHeight = () => setViewportHeight(viewport.height);
    updateHeight();
    viewport.addEventListener("resize", updateHeight);
    return () => viewport.removeEventListener("resize", updateHeight);
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={() => { if (!isSubmitting) onHide(); }}
      keyboard={!isSubmitting}
      backdrop={isSubmitting ? "static" : true}
      centered
      dialogClassName="selector-modal class-student-picker-modal"
      aria-labelledby="class-student-picker-title"
      onEntered={node => {
        // This Bootstrap/overlays version hides its own dialog and puts the label on the inner document.
        node.removeAttribute("aria-hidden");
        node.setAttribute("aria-labelledby", "class-student-picker-title");
      }}
      style={viewportHeight ? { "--student-picker-height": `${viewportHeight * 0.8}px` } : undefined}
    >
      <Modal.Header>
        <Modal.Title id="class-student-picker-title">Dodaj ucznia do zajęć</Modal.Title>
        <button type="button" className="close" aria-label="Zamknij" disabled={isSubmitting} onClick={onHide}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>Wybierz ucznia, aby od razu dodać go do zajęć</p>
        {error && <div role="alert" className="alert alert-danger">{error}</div>}
        {isSubmitting && <p role="status">Dodawanie ucznia…</p>}
        {show && (
          <ListItemSelector
            label=""
            options={options}
            onSelect={onSelect}
            disabled={isSubmitting}
            searchLabel="Szukaj ucznia lub klienta"
            keyboardButtonText="Schowaj klawiaturę"
            emptyMessage="Brak uczniów do dodania"
            noResultsMessage="Brak uczniów pasujących do wyszukiwania"
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

ClassStudentPickerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ClassStudentPickerModal;
